module.exports = __webpack_public_path__ + "img/1.a5db4f4b.jpg";